import { makeDynamicConfigWidgets } from '~/helper/makeDynamicConfigWidgets';

export const dashboardWidgets = makeDynamicConfigWidgets([
  {
    name: 'welcome',
    cols: 4,
    rows: 1,
  },
  {
    name: 'evaluation',
    cols: 4,
    rows: 1,
  },
  {
    name: 'propertyProgress',
    cols: 4,
    rows: 1,
  },
  {
    name: 'marketDynamic',
    cols: 4,
    rows: 1,
  },
  {
    name: 'nearObjects',
    cols: 8,
    rows: 1,
  },
  { name: 'heroCTAWidget', cols: 12, rows: 1 },
  {
    name: 'offer',
    cols: 6,
    rows: 1,
  },
  {
    name: 'blog',
    cols: 6,
    rows: 1,
  },
]);
